<template>
    <div data-cy="login-popup" class="login-pop-up">
        <div class="heading-wrap">
            <h3 v-if="!open_forgot_pass">{{  'Login' | translate | capitalize }}</h3>
            <h3 v-else>{{ 'Password Reminder' | translate | capitalize }}</h3>
        </div>
        <div class="content-wrap">
            <div class="form-con" v-if="!open_forgot_pass">
                <div class="wrapper">
                    <form autocomplete="off" @submit.prevent="login">
                        <div class="input-group-wrapper">
                            <div :class="[{ 'has-error': email_or_nick.error_msg }, 'form-group']">
                                <label>{{ 'Enter username or Email' | translate }}</label>
                                <div class="input-wrapper">
                                    <input class="form-control username-field" type="text" :placeholder="'Username' | translate" v-model="email_or_nick.val" @blur="checkEmptyEmail($event, 'email_or_nick')">
                                </div>
                                <form-notification data-cy="email-err-msg" v-if="email_or_nick.error_msg" :message="'Enter username or Email' | translate" />
                            </div>
                            <div :class="[{ 'has-error': password.error_msg }, 'form-group']">
                                <label>{{ 'Password' | translate}}</label>
                                <div class="input-wrapper">
                                    <input class="form-control password-field" :type="`${ show_password ? 'text' : 'password' }`" :placeholder="'Password' | translate" v-model="password.val" />
                                    <svg height="24" width="24" :class="`t-icon icon-right ${show_password ? 'eye-slash': 'eye'}`" @click.stop="show_password = !show_password"></svg>
                                </div>
                                <div data-cy="password-errmsg" v-if="password.error_msg" class="error-msg-con">
                                  {{ 'Enter Password' | translate }}
                                </div>
                            </div>
                            <div data-cy="login-pop-error-all" v-if="error_all" class="form-group">
                              <form-notification :message="'Username or password is incorrect' | translate" />
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="link-wrapper">
                                <a href="#" @click.prevent="openForgotPass">
                                    <span class="forgot-text">{{ 'I forgot my password' | translate }}</span>
                                </a>
                            </div>
                        </div>
                        <div class="form-group mb-0">
                            <div class="btn-wrapper">
                                <button data-cy="login-submit" class="btn btn-orange">
                                    <span>{{ 'Login' | translate }}</span>
                                </button>
                                <template v-if="oauthProviders.length">
                                    <p class="divider">{{ 'OR' | translate }}</p>
                                    <button :class="`btn btn-${provider}-oauth`" @click.prevent="redirectOauth(provider)" v-for="provider in oauthProviders" :key="provider">
                                        <i :class="`icon icon-${provider}`"></i>
                                        <span class="icon-bg"></span>
                                        <span>{{ `Connect with ${capitalize(provider)}` | translate }}</span>
                                    </button>
                                    <form-notification
                                      v-if="error_google_connect || error_yahoo_connect || error_apple_connect || error_microsoft_connect"
                                      :class="`error-msg-con ${provider}-connect`"
                                      :message="'This email address is not registered, please sign up to log in.' | translate" 
                                    />
                                </template>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <forgot-password v-if="open_forgot_pass" />
        </div>
    </div>
</template>

<script>
    import ForgotPassword from '@theme-views/public/pages/Login/ForgotPassword'
    import Login from '@views/public/pages/Login/login'
    import SvgUser from '@theme-views/common/SvgIcon/Icons/User'
    import SvgLock from '@theme-views/common/SvgIcon/Icons/Lock'
    import {checkNull} from '@/helpers'
    import FormNotification from '@theme-views/common/FormNotification'

    delete Login.methods.login

    export default {
        mixins: [Login],
        data() {
            return {
                open_forgot_pass: false,
                cdn_url: window.APP_CONFIG.CDN_URL,
                show_password: false
            }
        },
        methods: {
            openForgotPass() {
                this.open_forgot_pass = true
            },
            routeCheck(route) {
              this.open_forgot_pass = checkNull(route.query.openForgotPass) ? true : false
            },
            routeToDashboard() {
                this.$router.push({ name: 'user-home' })

                this.$nextTick(() => {
                    this.$root.$children[0].resetMobileScroll()
                })
            },
            changeModalToForgotPass() {
                //overrride so that it won't change modal settings
            },
            login() {
                let _this = this
                this.error_all = false
                this.email_or_nick.error_msg = ''
                this.password.error_msg = ''
                this.$store.dispatch('auth/login', { params: {
                        email_or_nick: this.email_or_nick.val,
                        password: this.password.val
                    }, success_cb(response) {
                        if(response.data.redirect) {
                            safeRedirect(response.data.redirect);
                        } else {
                            _this.$store.dispatch('profile/populateProfiles')
                            _this.$store.dispatch('pub/getFormValues')
                            _this.$store.dispatch('message/getIcebreakers')
                            _this.routeToDashboard()
                        }
                    }, error_cb(response) {
                        _this.error_all = true
                        if(typeof response.data.email_or_nick != 'undefined')
                            _this.email_or_nick.error_msg = 'true'
                        if(typeof response.data.password != 'undefined')
                            _this.password.error_msg = 'true'
                        if(response.data.error === 'deleted') {
                            _this.$router.push({ name: 'account-deleted', params: { status: 'success', redirect: response.data.redirect || null} })
                            // temporary alert for testing purposes
                            _this.$root.$children[0].handleToastMsg({
                                type: 'error',
                                msg: _this.$t('Account Deleted')
                            })
                        }
                    }
                })
            },
        },
        watch: {
            '$route' (to, from) {
                this.routeCheck(to)
            }
        },
        created() {
            this.routeCheck(this.$route)
        },
        components: {
            ForgotPassword,
            SvgUser,
            SvgLock,
            FormNotification,
        }
    }
</script>

<style lang="scss" scoped>
.login-pop-up {
  width: 606px;
    @media #{$tablet-portrait} {
      width: 100%;
    }
    .form-group {
        margin-bottom: 16px;
        > label {
            margin-bottom: 8px;
            display: flex;
            font-size: 20px;
            color: #797979;
            @media #{$tablet-portrait} {
              font-size: 16px;
            }
        }
        .link-wrapper {
            display: flex;
            justify-content: flex-end;
            .forgot-text {
                text-transform: uppercase;
                font-size: 14px;
                @include font-settings(normal, normal, normal, normal, 600);
                color: var(--sd-secondary-normal);
            }
        }
        .btn-wrapper {
            .btn {
                width: 100%;
                @media #{$tablet-portrait} {
                  margin-bottom: 15px;
                }
                &:nth-child(2) {
                    margin-bottom: 30px;
                }
                &:not(:last-child) {
                    margin-bottom: 0;
                }
            }
        }
    }
    p.divider {
        color: #4a4a4a;
        text-align: center;
    }

    .input-wrapper {
      .icon-right {
        cursor: pointer;
        position: absolute;
        right: 10px;
        top: 14px;
        background: #53a7d6;
      }
    }
}
</style>
